// Typen für Backup & Restore (Hetzner Storage Box)

export interface HetznerStatus {
  configured: boolean;
  host?: string;
  username?: string;
  remotePath?: string;
  authMethod?: 'password' | 'key';
}

export interface RemoteBackupFile {
  name: string;
  size: number;
  modifiedAt: string; // ISO-8601
}

export interface RestoreReport {
  /** Formatversion der eingelesenen Datei (1 = Backup vor dem Ausbau). */
  sourceVersion: number;
  /** Eingespielte Datensätze je Tabelle, benannt wie BACKUP_TABLE_LABELS. */
  restored: Record<string, number>;
  trees: number;
  treeMemberships: number;
  mediaFilesRestored: number;
  mediaFilesMissing: number;
  /** Alles, was nicht 1:1 übernommen werden konnte. */
  notes: string[];
}

/**
 * Deutsche Bezeichnungen der gesicherten Tabellen – gemeinsam genutzt von der
 * Backup-Seite und der Stammbaum-Sicherung. Die Reihenfolge bestimmt die
 * Anzeige und geht von „viel" nach „Detail".
 */
export const BACKUP_TABLE_LABELS: Record<string, string> = {
  persons: 'Personen',
  relationships: 'Beziehungen',
  familyMembers: 'Eltern-Kind-Zuordnungen',
  albums: 'Alben',
  media: 'Dateien',
  sources: 'Quellen',
  mediaPersons: 'Datei-Zuordnungen',
  sourcePersons: 'Quellen-Zuordnungen',
  factCitations: 'Belege je Angabe',
  occupations: 'Laufbahn-Stationen',
  biographies: 'Lebensläufe',
  personConditions: 'Diagnosen',
  personTraits: 'Merkmale',
  medicalConsents: 'Einwilligungen',
  conditionSources: 'Belege zu Diagnosen',
};

// ─── Automatische Backups ─────────────────────────────────────────────────────

export type BackupInterval = 'daily' | 'weekly' | 'monthly';
export type BackupLastStatus = 'success' | 'error';

export interface BackupScheduleConfig {
  enabled: boolean;
  interval: BackupInterval;
  /** Uhrzeit als HH:MM, z. B. "02:00" */
  time: string;
  /** Wochentag 0–6 (0 = Sonntag) – nur relevant bei interval = 'weekly' */
  dayOfWeek: number;
  /** Tag im Monat 1–28 – nur relevant bei interval = 'monthly' */
  dayOfMonth: number;
  /** Wie viele Backups auf der Storage Box behalten (0 = unbegrenzt) */
  keepLast: number;
  lastRunAt: string | null;   // ISO-8601
  lastStatus: BackupLastStatus | null;
  lastError: string | null;
  nextRunAt: string | null;   // ISO-8601, vom Server berechnet
}
